import { LinkButton, Container } from '@hg/stylizator/components'
import { useSizes } from '@hg/stylizator/hooks'
import { Text } from '@hg/stylizator/typography'
import { Spacing, Flex, desktop } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

import { useTranslation } from 'app/hooks/use-translation'
import { GIFT_COUPON_URL } from 'app/parameters'
import theme from 'app/styles/theme'

const BottomCTA: React.FC = () => {
  const { isDesktop } = useSizes()
  const t = useTranslation()

  return (
    <Flex flexDir="column" style={{ overflowX: 'hidden' }}>
      <BackgroundView>
        <Container>
          <Text type="heading_large" useCompact>
            <p>{t('ready_to_make_sweet_money')}</p>
          </Text>
          <Spacing top={2} />
          <Text type={isDesktop ? 'heading_small' : 'body'}>
            <small>{t('join_today_and_earn_sweet_money')}</small>
          </Text>
          <Spacing top={5} />
          <LinkButton className="target-blog-get-started" type="primary" size="large" href={GIFT_COUPON_URL}>
            <Text type="label" color={theme.color.white}>
              <span>{t('get_started')}</span>
            </Text>
          </LinkButton>
          <Spacing top={[16, 12]} />
        </Container>
      </BackgroundView>
    </Flex>
  )
}

const BackgroundView = styled.div`
  margin-top: -97px;
  padding-top: 100px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.color.blue['20']};

  & .target-blog-get-started {
    display: inline-flex;
    width: 100%;

    @media ${desktop} {
      width: 170px;
    }
  }
`

export default React.memo(BottomCTA)
